import { z } from 'zod';
import { ModalitaRaccoltaSchema } from './raccolta-delega.ts';
import type { ModalitaRaccolta } from './raccolta-delega.ts';

const str = z.string().nullable().default(null);

export const ArchivioSchema = z.object({
  id: z.number(),
  codFiscale: z.string(),
  codCe: str,
  codEc: str,
  datapres: str,
  cognNome: str,
  indirizzo: str,
  citta: str,
  prov: str,
  cap: str,
  telefono: str,
  note: str,
  operatore: str,
  origine: z.string().default('IMPORT'),
  coloreId: z.number().nullable().default(null),
  modalitaRaccolta: ModalitaRaccoltaSchema.nullable().default(null),
  // Data inserimento (UTC), solo per i record inseriti dopo la migrazione 005
  createdAt: str,
});

export type Archivio = z.infer<typeof ArchivioSchema>;

export interface ArchivioInsert {
  codFiscale: string;
  cognNome: string | null;
  indirizzo: string | null;
  citta: string | null;
  prov: string | null;
  cap: string | null;
  telefono: string | null;
  note: string | null;
  operatore: string | null;
  dataNascita: string | null;
  coloreId: number;
  modalitaRaccolta: ModalitaRaccolta;
}
